import { Pagination } from 'react-bootstrap';

export default function DashboardTablePagination({ currentPage, totalPages, onPageChange }) {
  if (totalPages <= 1) return null;

  const maxVisible = 10;
  const surrounding = 3;
  const pages = [];

  if (totalPages <= maxVisible) {
    for (let i = 1; i <= totalPages; i += 1) pages.push(i);
  } else {
    pages.push(1);
    let start = Math.max(2, currentPage - surrounding);
    let end = Math.min(totalPages - 1, currentPage + surrounding);
    const desired = maxVisible - 2;
    if (end - start + 1 < desired) {
      if (currentPage < totalPages / 2) end = Math.min(totalPages - 1, start + desired - 1);
      else start = Math.max(2, end - desired + 1);
    }
    if (start > 2) pages.push('ellipsis-start');
    for (let i = start; i <= end; i += 1) pages.push(i);
    if (end < totalPages - 1) pages.push('ellipsis-end');
    if (totalPages > 1) pages.push(totalPages);
  }

  return (
    <Pagination className="justify-content-center mt-16 mb-0">
      <Pagination.First disabled={currentPage === 1} onClick={() => onPageChange(1)} title="First" />
      <Pagination.Prev disabled={currentPage === 1} onClick={() => onPageChange(currentPage - 1)} />
      {pages.map((page) =>
        page === 'ellipsis-start' || page === 'ellipsis-end' ? (
          <Pagination.Item key={page} disabled>
            &hellip;
          </Pagination.Item>
        ) : (
          <Pagination.Item key={page} active={currentPage === page} activeLabel={null} onClick={() => onPageChange(page)}>
            {page}
          </Pagination.Item>
        )
      )}
      <Pagination.Next
        disabled={currentPage === totalPages}
        onClick={() => onPageChange(currentPage + 1)}
      />
      <Pagination.Last
        disabled={currentPage === totalPages}
        onClick={() => onPageChange(totalPages)}
        title="Last"
      />
    </Pagination>
  );
}
